import { Injectable } from '@angular/core';
import { FMenu } from './fmenu';

@Injectable({
  providedIn: 'root'
})
export class FunctionMenuService {

  constructor() { }

  private _menus: FMenu[] = [];
  private _listener: () => void;

  listener(l: () => void) {
    this._listener = l;
  }

  get menus(): FMenu[] {
    return this._menus;
  }

  set menus(menus: FMenu[]) {
    this._menus = menus;
    this.disableMenu();
    if (this._listener) {
      this._listener();
    }
  }

  public disableMenu() {
    this._menus.forEach(m => m.disableMenuItems());
  }

  public clear() {
    this.menus = [];
  }
}
